import { Box } from "@mui/material";
import successSvg from "@ob/assets/svgs/stitch-success.svg";

type Props = {
  style?: object;
  size?: "small" | "medium" | "large";
};
export default function StitchSuccessIcon({
  style = {},
  size = "medium",
}: Props) {
  const small = (
    <Box sx={{ ...style }}>
      <img src={successSvg} alt="Success" style={{ width: "50px" }} />
    </Box>
  );
  if (size === "small") {
    return small;
  }

  const medium = (
    <Box sx={{ ...style }}>
      <img src={successSvg} alt="Success" style={{ width: "180px" }} />
    </Box>
  );
  if (size === "medium") {
    return medium;
  }

  return (
    <Box sx={{ ...style }}>
      <img src={successSvg} alt="Success" />
    </Box>
  );
}
